import React, { useCallback } from 'react'
import Tree from 'components/Tree'

import CashRegister from './CashRegister'
import Shop from './Shop'
import Region from './Region'
import Department from './Department'
import query from 'gql/query/cashRegistersTree'
import { useQuery } from 'components/graphql'

const CashRegisterTree = ({ cardsInRow = 2, onOldCrIconClick, ...props }) => {
	const { data } = useQuery(query, { fetchPolicy: 'cache-first' })
	const NodeComponent = useCallback(nodeProps => {
		const { nodeData, children } = nodeProps
		switch (nodeData.__typename) {
			case 'Department':
				return (
					<Department {...nodeProps} cardsInRow={cardsInRow}/>
				)
			case 'Region':
				return (
					<Region {...nodeProps}/>
				)
			case 'Shop':
				return (
					<Shop {...nodeProps}/>
				)
			case 'CashRegister':
				return (
					<CashRegister onOldCrIconClick={onOldCrIconClick} {...nodeProps}/>
				)
			default:
				return children
		}
	}, [cardsInRow])

	return(
		<Tree
			{...props}
			data={data}
			NodeComponent={NodeComponent}
		/>
	)
}

export default CashRegisterTree
